<template>
  <div>
    <div
      v-if="credentials.length > 1"
      class="owal-user-tabs__container"
      id="owal-credentials-tab"
      >
      <div
        v-for="(credential, index) in credentials"
        :key="credential.credential_uuid"
        :class="`owal-user-tab__container ${(currentCredentialIndex === index) ? 'active_tab' : ''}`"
        >
        <div
          @click="setCurrentCredential(index)"
          >
          {{ `Badge ${index + 1}` }}
        </div>
      </div>
    </div>
    <div style="display: flex; flex-direction: row; height:100%" class="profile-display-buttons">
      <div class="owal-user-tabs__optional" style="margin-left: auto; flex: 0 0 20%">
        <owal-button
          class="credential-mistmatch-panel__print-button"
          :title="'delete'"
          style="margin-right: .5rem;"
          @click="$emit('deactivate-profile')"
          >
          <div
            class="credential-mismatch-panel__button-tooltip"
            >
            Delete
          </div>
          <div style="min-width: 3rem; display: flex; flex-direction: row; justify-content: center;">
            <font-awesome-icon
              slot="accessory"
              icon="user-slash"
              />
          </div>
        </owal-button>
        <owal-button
          class="credential-mistmatch-panel__print-button"
          :title="'edit'"
          style="margin-right: .5rem;"
          @click="$emit('edit-profile')"
          >
          <div
            class="credential-mismatch-panel__button-tooltip"
            >
            Edit
          </div>
          <div style="min-width: 3rem; display: flex; flex-direction: row; justify-content: center;">
            <font-awesome-icon
              slot="accessory"
              icon="pen"
              />
          </div>
        </owal-button>
      </div>
      <div
        class="owal-user-tabs__container" style="flex: 2;">
        <div
          :class="`owal-user-tab__container ${(filterMode === 'current') ? 'active_tab' : ''}`"
          @click="setFilter('current')"
          >
          Verifiable Activity
        </div>
        <div
          :class="`owal-user-tab__container ${(filterMode === 'all') ? 'active_tab' : ''}`"
          @click="setFilter('all')"
          >
          All Activity
        </div>
        <div
          :class="`owal-user-tab__container ${(filterMode === 'match') ? 'active_tab' : ''}`"
          @click="setFilter('match')"
          >
          Verified Matches
        </div>
      </div>
      <div class="owal-user-tabs__optional" style=" margin-left: auto; justify-content: center; flex: 0 0 20%;">
        <owal-button
          class="credential-mistmatch-panel__print-button"
          :title="''"
          style="margin-right: .5rem;"
          @click="downloadReport('identity')"
          >
          <div
            class="credential-mismatch-panel__button-tooltip"
            >
            Download Tenant Report
          </div>
          <div style="min-width: 3rem; display: flex; flex-direction: row; justify-content: center;">
            <font-awesome-icon
              v-if="loadingReport.identity"
              id="loading-spinner"
              icon="spinner"
              />
            <font-awesome-icon
              v-else
              slot="accessory"
              icon="user"
              />
          </div>
        </owal-button>
        <owal-button
          v-show="cotenants"
          class="credential-mistmatch-panel__print-button"
          :title="''"
          style="margin-left: .5rem;"
          @click="downloadReport('unit')"
          >
          <div
            class="credential-mismatch-panel__button-tooltip"
            >
            Download Unit Report
          </div>
          <div style="min-width: 3rem; display: flex; flex-direction: row; justify-content: center;">
            <font-awesome-icon
              v-if="loadingReport.unit"
              id="loading-spinner"
              icon="spinner"
              />
            <font-awesome-icon
              v-else
              slot="accessory"
              icon="users"
              />
          </div>
        </owal-button>
      </div>
    </div>
  </div>
</template>

<script>
import OwalButton from '@/libraries/owal-ui/buttons/OwalButton'

export default {
  name: 'credential-profile-toolbar',
  components: { OwalButton },
  props: {
    cotenants: {
      type: Boolean,
      default: false,
    },
    credentials: {
      type: Array,
    },
    identityId: {
      type: String,
    },
    loadingReport: {
      type: Object,
    },
  },
  data () {
    return {
      filterMode: 'current',
      currentCredentialIndex: 0,
    }
  },
  methods: {
    setCurrentCredential (index) {
      this.currentCredentialIndex = index
      this.$emit('credential-change', index)
    },
    setFilter (filter) {
      this.filterMode = filter
      this.$emit('filter-change', filter)
    },
    downloadReport (identifier) {
      this.$emit('download-report', identifier)
    },
  },
  watch: {
    identityId () {
      this.currentCredentialIndex = 0
    },
  },
}
</script>

<style scoped>
.owal-user-tab__container.active_tab {
  background: rgb(71, 86, 105);
  color: rgb(239, 242, 247);
}

.owal-user-tab__container:nth-of-type(1) {
  border-top-left-radius: 0.35rem;
  border-bottom-left-radius: 0.35rem;
}

.owal-user-tab__container:nth-last-child(1) {
  border-top-right-radius: 0.35rem;
  border-bottom-right-radius: 0.35rem;
}

.owal-user-tab__container:hover {
  background: rgba(71, 86, 105, 0.2);
  color: rgb(71, 86, 105);
}

.owal-user-tab__container {
  display: flex;
  align-content: center;
  align-items: center;
  margin: 0;
  border-collapse: collapse;
  border: 1px solid rgb(71, 86, 105);
  padding: 0.35rem;
  cursor: pointer;
}
.owal-user-tabs__container {
  display: flex;
  height: 3rem;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.owal-user-tabs__optional {
  display: flex;
  height: 3rem;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.credential-mismatch-panel__button-tooltip {
  opacity: 0;
  max-width: 0;
  white-space: nowrap;
  font-size: 0.75rem;
  color: #fff;
  border-radius: 0.35rem;
  margin: 0;
  z-index: 1;
  transition: opacity 350ms ease, max-width 250ms ease;
}

.credential-mistmatch-panel__print-button:hover .credential-mismatch-panel__button-tooltip {
  opacity: 1;
  width: inherit;
  max-width: 200px;
  color: #000000;
}

#loading-spinner {
  animation: spinner-spin infinite 1.0s ease-in-out;
}

@keyframes spinner-spin {
  0% {transform: rotate(180deg); }
  50% {transform: rotate(-180deg);}
  100% {transform: rotate(180deg); }
}
</style>
